import React, { FC } from 'react'
import TextField from '@material-ui/core/TextField'
import {
  getSorting,
  SORTING_CHEAP,
  SORTING_EXPENSIVE,
  SORTING_NEW,
  useTranslation
} from '@plandi/common'

import MenuItem from '@material-ui/core/MenuItem'

import { useProjectsFiltersStyles } from './projects-filters.styles'
import { useProjectsFilters } from '../use-projects-filters'
// import clsx from 'clsx'

type ProjectsFiltersSortProps = {
  class: 'sort' | 'mobileSort'
  setIsSortClicked?: () => void
  isDisabled?: boolean
}

export const ProjectsFiltersSort: FC<ProjectsFiltersSortProps> = (props) => {
  const classes = useProjectsFiltersStyles()
  const { data: translate } = useTranslation()
  const { sort, setProjectsFilters } = useProjectsFilters()

  return (
    <TextField
      select
      value={sort || 'new'}
      fullWidth
      // className={clsx([classes[props.class]])}
      className={classes[props.class]}
      inputProps={{ style: { fontSize: 14 } }}
      onChange={(event) =>
        setProjectsFilters({ sort: event.target.value as typeof sort })
      }
      disabled={!!props.setIsSortClicked}
      onClick={props.setIsSortClicked}
      // SelectProps={{
      //   MenuProps: {
      //     className: clsx([
      //       {
      //         [classes.popover]: props.class === 'sort'
      //       },
      //       classes.dropdown
      //     ])
      //   }
      // }}
      SelectProps={{
        MenuProps: {
          className: props.class === 'sort' ? '' : classes.popover
        }
      }}
    >
      {[SORTING_NEW, SORTING_CHEAP, SORTING_EXPENSIVE].map((key) => (
        <MenuItem key={key} value={key}>
          {/* {getSorting(translate)[key as keyof ReturnType<typeof getSorting>]} */}
          {translate &&
            getSorting(translate)[key as keyof ReturnType<typeof getSorting>]}
        </MenuItem>
      ))}
    </TextField>
  )
}
